<template>
    <ul class="icon-menu">
        <li>
            <a href="#">Icon</a>
        </li>
        <li>
            <a href="#">Icon</a>
        </li>
    </ul>
</template>

<script>
export default {};
</script>
